<template>
  <div>
    <v-form ref="CargaMasivaForm">
      <v-row>
        <v-col cols="12" md="3"> </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            label="Campaña"
            :rules="required"
            v-model="form.campania_id"
            :items="campanias"
            item-text="producto"
            item-value="id"
            outlined
            primary
            :readonly="readOnly"
            color="#00a7e4"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-file-input
            label="Archivo de Carga Masiva"
            v-model="form.file"
            primary
            accept=".csv,.XLS,.XLSX"
            color="#00a7e4"
            outlined
            :rules="required"
          ></v-file-input>
        </v-col>
      </v-row>
    </v-form>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="#00a7e4"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
//las campañas seran estas ? ESTA EN EmbeddedCliente.vue VALIDAR CON LUIS
//import { getCampañasClientes } from "@/services/cliente/CampañasClientes.js";

import { saveCargaMasiva } from "@/services/disposiciones/disposiciones.service";

export default {
  components: {},
  data: () => {
    return {
      required: [(value) => !!value || "Campo Requerido"],
      form: {
        campania_id: null,
        file: null,
      },
      loading: false,
    };
  },
  props: {
    campanias: {
      type: Array,
      required: true,
    },
    toSave: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    cuentaId: {
      type: Number,
      default: null,
    },
  },
  watch: {
    toSave(val) {
      if (val) this.GuardarMasiva();
    },
  },
  computed: {},
  mounted() {},
  methods: {
    async GuardarMasiva() {
      this.loading = true;

      if (!this.$refs.CargaMasivaForm.validate()) {
        this.$emit("goTosave", { ok: false });
        return;
      }
      const fd = new FormData();
      fd.append("campania_id", this.form.campania_id);
      fd.append("file", this.form.file);

      try {
        const { data } = await saveCargaMasiva(fd);
        if (data.inserted > 0) 
        this.$toast.success(
          `Se insertaron ${data.inserted} dispociciones con éxito`
        );
        if (data.updated > 0) {
          this.$toast.success(
            `Se actualizaron ${data.updated} dispociciones con éxito`
          );
        }
        if (data.failed > 0) {
          this.$toast.warning(
            `No se pudieron insertardata.failed} dispociciones`
          );
        }

        if (data.inserted == 0 && data.updated == 0 && data.failed == 0) {
          this.$toast.warning(
            `No se encontro ninguna disposición para insertar o actualizar`
          );
        }

        this.$emit("goTosave", { ok: true });
      } catch (error) {
        const msg =
          error.response?.data?.message ||
          error.message ||
          "Ocurrió un error al crear la disposición.";
        const toastType = this.getToastType(error);
        this.$toast[toastType](msg);
        this.$emit("goTosave", { ok: false });
      } finally {
        this.loading = false;
      }
    },
    getToastType(error) {
      const status = error?.response?.status;
      return status === 400 ? "warning" : "error";
    },
  },
};
</script>

<style scoped>
.v-application p {
  margin-bottom: 0px !important;
}
</style>
